import React, { Component } from 'react';
import './HandHistory.css';
import HandHistoryHeader from './HandHistoryHeader';
import HandCardMobile from './HandCardMobile';
import $ from 'jquery';
import { connect } from "react-redux";
import NoHandsAvailable from './NoHandsAvailable';
import { getColor, getTextColor } from '../../common/ThemeService';
import i18next from 'i18next';

class HandHistoryMobile extends Component {
    render() {
        const themeColor = getColor()
        const themeTextColor = getTextColor()
        return (
            <div className="hand-history-main">
                <style>{`\
        body{\
          background-color:white !important;\
        }\
        #HH_return-to-top:hover {\
            background-color: ${themeColor};\
            color: ${themeTextColor};\
          }\
      `}</style>
                <div style={{ padding: 0 }} className="hand-history-height-100 container">
                    <div>
                        <HandHistoryHeader
                            showReplayBtn={this.props.showReplayBtn}
                            showMultiReplayer={this.props.showMultiReplayer}
                            setShowFilterModal={this.props.setShowFilterModal}
                            hands={this.props.totalHands} totalProfit={this.props.totalProfit} />
                        <div className="border-bottom-hand-history border_full_length"></div>
                    </div>
                    <div id="HH_mainScroll" style={{ marginTop: "3px", marginRight: "0px" }} className="row background-handHistory padding-hand-history">
                        <div style={{ marginBottom: "0" }} className=" table-header-width margin-bottom-0">
                            {this.props.handList.map((hand, i) =>
                                <HandCardMobile
                                    isAllHandsSelected={this.props.isAllHandsSelected}
                                    selectHand={(hand) => {
                                        this.props.selectHand(hand, i)
                                    }}
                                    unselectHand={(hand) => {
                                        this.props.unselectHand(hand, i)
                                    }}
                                    key={i}
                                    openNotes={this.props.openNotes}
                                    hand={hand}
                                    setStarFlagOfHnad={this.props.setStarFlagOfHnad}>
                                </HandCardMobile>
                            )}
                            {!this.props.loading && (!this.props.handList || this.props.handList.length === 0) ?
                                <NoHandsAvailable i18next={i18next} setShowFilterModal={this.props.setShowFilterModal} /> : null
                            }
                            {!this.props.loading && this.props.showMoreFlag && <div className="pagination_wrap"><div className="MyHands_show_more_button" onClick={(e) => {
                                e.preventDefault();
                                this.props.showMoreClicked();
                            }}>{i18next.t("lable.showMore")}</div>
                            </div>}
                        </div>
                    </div>
                </div>
                <div>
                    {this.props.showTopButton ? <div id="HH_return-to-top" onClick={() => {
                        $('html').scrollTop(0);
                    }}><i style={{ fontSize: "25px" }} className="fa fa-angle-double-up"></i></div>
                        : null}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedHandList: state.handHistory.selectedHandList,
        lang: state.header.lang
    }
}

export default connect(mapStateToProps, null)(HandHistoryMobile);



/** WEBPACK FOOTER **
 ** ./src/components/HandHistory/HandHistoryMobile.js
 **/